import MultiSelectFilter from '../../Filter/MultiSelectFilter';
import { useTranslation } from 'react-i18next';

const DisposedByFilter = ({ asPanel, initialValue, onChange }: {
  asPanel?: boolean,
  initialValue: string[],
  onChange: (ids: string[]) => void,
}) => {
  const { t } = useTranslation();

  const data = [
    { id: "System", value: t('filters.disposedByFilter.expired') },
    { id: "Seller", value: t('filters.disposedByFilter.bySeller') },
  ];

  return (
    <MultiSelectFilter
      asPanel={asPanel}
      data={data}
      initialValue={initialValue}
      onChange={onChange}
      placeholder={t('filters.disposedByFilter.title')}
    />
  );
};

export default DisposedByFilter;
